import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "semantic-ui-react";
import { getPublicRoles } from "../actions/publicRoles/publicRoles";
import { registerAccount } from "../actions/registrations/registrations";
import { getUserTypes } from "../actions/users/users";
import RegisterAccount from "../components/registrations/RegisterAccount";
import { amRoutes } from "../config/config";
import { history } from "../store";
import { hideSuccessMessage, hideFailureMessage } from "../store/statusMessages";

const RegisterAccountView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPublicRoles());
    dispatch(getUserTypes());
  }, [dispatch]);
  const [
    userTypes,
    loading,
    showSuccessMessage,
    submitSucceededMessageHeader,
    submitSucceededMessageContent,
    showFailureMessage,
    submitFailedMessageHeader,
    submitFailedMessageContent,
    publicRoles
  ] = useSelector(({ users, registrations, statusMessages, publicRoles }) => [
    users.userTypes,
    registrations.loading,
    statusMessages.showSuccessMessage,
    statusMessages.submitSucceededMessageHeader,
    statusMessages.submitSucceededMessageContent,
    statusMessages.showFailureMessage,
    statusMessages.submitFailedMessageHeader,
    statusMessages.submitFailedMessageContent,
    publicRoles.roles
  ]);
  return (
    <Container style={{ width: "500px" }}>
      <RegisterAccount
        onCancel={() => {
          history.push(amRoutes.login);
          dispatch(hideSuccessMessage());
          dispatch(hideFailureMessage());
        }}
        userTypes={userTypes}
        loading={loading}
        publicRoles={publicRoles}
        showSuccessMessage={showSuccessMessage}
        showFailureMessage={showFailureMessage}
        successMessageHeader={submitSucceededMessageHeader}
        successMessageContent={submitSucceededMessageContent}
        failureMessageHeader={submitFailedMessageHeader}
        failureMessageContent={submitFailedMessageContent}
        onSubmit={values => dispatch(registerAccount(values))}
      />
    </Container>
  );
};

export default RegisterAccountView;
